export default __webpack_public_path__ + "static/media/warning-sign.3bca9c54.svg";